module.exports = "//static.hsappstatic.net/LoginUI/static-1.14135/img/connect.com-full-logo-color.svg"